import type { FC } from "react";
import { Card } from "@/components/podkit/Card";
import { Text } from "@/components/podkit/typography/Text";
import { Tooltip } from "@/components/Tooltip";
import { OCU } from "@/routes/settings/organization/billing/OCU";

type Props = {
    totalCredits: number;
    availableCredits: number;
    usedCredits: number;
};

export const CreditSummaryCard: FC<Props> = ({ totalCredits, availableCredits, usedCredits }) => {
    const remainingPct = totalCredits > 0 ? Math.round((availableCredits / totalCredits) * 100) : 0;
    const usedPct = totalCredits > 0 ? Math.round((usedCredits / totalCredits) * 100) : 0;

    return (
        <Card className="p-6">
            <div className="mb-1 flex items-baseline justify-between">
                <Text className="text-lg font-semibold text-content-primary">Credits</Text>
                <Text className="text-sm text-content-secondary">
                    {Math.round(availableCredits).toLocaleString()} <OCU /> remaining
                </Text>
            </div>

            <Tooltip
                content={`${remainingPct}% remaining · ${usedPct}% used`}
                inverted={false}
                usePortal={true}
            >
                <div className="h-4 w-full cursor-default rounded-full border border-surface-04 bg-surface-glass p-0.5">
                    <div className="h-full overflow-hidden rounded-full bg-surface-glass">
                        <div
                            className="h-full rounded-full bg-gradient-to-r from-orange-100 to-orange-300 transition-all duration-300"
                            style={{ width: `${remainingPct}%` }}
                        />
                    </div>
                </div>
            </Tooltip>

            <div className="mt-1 flex justify-between">
                <Text className="text-sm text-content-secondary">0</Text>
                <Text className="text-sm text-content-secondary">
                    {Math.round(totalCredits).toLocaleString()} <OCU /> total
                </Text>
            </div>
        </Card>
    );
};
